export function timeStringToHours(time: string): number {
  const timeParts = time.split(":");
  return parseInt(timeParts[0]) + parseInt(timeParts[1]) / 60;
}

export function timeStringToMinutes(time: string): number {
  const timeParts = time.split(":");
  return parseInt(timeParts[0]) * 60 + parseInt(timeParts[1]);
}
